import { Address } from './address';
import { Borrower } from './user';

export interface SubjectProperty extends Address {
  propertyType: string;
  noOfUnits: number;
  beds: number;
  baths: number;
  yearBuilt: number;
  size: number;
  lotSize: number;
  vacant: boolean;
  noVacantDescription: string;
}

export interface PartnerData {
  company?: string;
  contactName?: string;
  contactPhone?: string;
  contactEmail?: string;
}

export interface LoanInformation {
  purchasePrice: number;
  renovationBudget: number;
  loanAmount: string; // TODO: use a number. We are currently putting the $ in the value
  loanTerm: number;
  coeDate: Date;
  closing?: PartnerData;
  insurance?: PartnerData;
}

export interface LoanComp {
  address: string;
  salePrice: number;
  saleDate: Date;
}

export interface RenovationInformation {
  timelineInWeeks: number;
  estCompletionDate: Date;
  linkToPhotos?: string;
  permitsRequired: boolean;
  permitTimeInWeeks: number;
  addingSqft: boolean;
  structuralWork: boolean;
  structuralDescription: string;
  foundationWork: boolean;
  foundationDescription: string;
  disasterRepairs: boolean;
  disasterDescription: string;
}

export interface SupportingDocuments {
  purchaseContract: boolean;
  renovationDocument: boolean;
  photos: boolean;
  compsIncluded: boolean;
}

export interface InvestmentSection {
  acknowledged: boolean;
}

export interface LoanApplicationSections {
  borrower?: Borrower;
  subjectProperty?: SubjectProperty;
  loanInformation?: LoanInformation;
  comps?: LoanComp[]; // TODO: use or create the comps data type
  renovationDetails?: RenovationInformation;
  supportingDocuments?: Record<string, unknown>;
  investmentPurposes?: InvestmentSection;
}

export interface LoanApplication extends LoanApplicationSections {
  id?: string; // randomly assigned
  status?: string; // submitted, received, approved, etc.
}

export type LoanAppFields = keyof LoanApplicationSections;
